// Entry point for the build script in your package.json

// External Dependencies (if available in node_modules, otherwise handled by global CDN)
import jQuery from "jquery"
window.$ = window.jQuery = jQuery

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
if (csrfToken && window.$?.ajaxSetup) {
	window.$.ajaxSetup({
		headers: { 'X-CSRF-Token': csrfToken }
	})
}

import Rails from "@rails/ujs"
Rails.start()
window.Rails = Rails
if (window.jQuery) {
	window.jQuery.rails = Rails
	window.$.rails = Rails
}

import _ from "underscore"
window._ = _

await import("./legacy_bundle")
